import React from "react";
import { Box, Typography, Button, Icon, useTheme } from "@mui/material";
import useSmoothResponsiveFontSize from "../../../../_hook/useSmoothResponsiveFontSize";

const TextSection = () => {
  const theme = useTheme();
  const customfontsize = useSmoothResponsiveFontSize();
  return (
    <Box
      sx={{
        flex: 1,
        textAlign: "center",
        display: "flex",
        flexDirection: "column",
        alignItems: "start",
        justifyContent: "start",
        textAlign: "start",
        width: "100%",
        p: 2,
        fontSize: `${customfontsize}px`,
      }}
    >
      <Typography
        variant="h2"
        sx={{
          p: 0,
          fontSize: `${3 * customfontsize}px`,
          width: "100%",
          pt: 3,
          color: "grey.700",
          mb: 2,
          position: "relative",
          display: "inline-block",
          textAlign: "start",
          overflow: "hidden",
          "& span": {
            position: "relative",
            marginLeft: 1,
            display: "inline-flex",
            alignItems: "center",
          },
        }}
      >
        Never Stop
        <Box
          component={"span"}
          style={{
            backgroundColor: theme.palette.warning.main,
            fontWeight: "bolder",
            paddingLeft: "10px",
            paddingRight: "10px",
            borderRadius: "10px",
            color: theme.palette.white.main,
          }}
        >
          Learning
        </Box>
        <br />
        Life{" "}
        <b style={{ fontWeight: "bolder", color: theme.palette.grey[800] }}>
          Never Stop
        </b>{" "}
        Teaching
      </Typography>

      <Typography
        variant="body1"
        sx={{
          mb: 4,
          fontSize: `${2 * customfontsize}px`,
          color: "grey.700",
          textAlign: "start",
        }}
      >
        Every teaching and learning journey is unique. Following We&apos;ll help
        guide your way.
      </Typography>

      <Button
        variant={"contained"}
        sx={{
          m: 0,
          px: 2,

          display: "flex",
          justifyContent: "start",
          alignItems: "center",
          boxShadow: "4px 4px 10px rgba(97, 97, 97, 0.8)",
          transition: "box-shadow 0.3s ease-in-out",
          "&:hover": {
            boxShadow: "0px 0px 0px rgba(0, 0, 0, 0)",
          },
        }}
      >
        <Typography
          variant="inherit"
          textTransform="capitalize"
          sx={{ fontSize: `${customfontsize}px` }}
          style={{
            padding: 0,
            margin: 0,
            color: "white",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            overflow: "hidden",
            textOverflow: "clip", // This property ensures that overflowing text is fully visible
            display: "-webkit-box",
            WebkitLineClamp: 1,
            WebkitBoxOrient: "vertical",
            lineClamp: 1,
            boxOrient: "vertical",
          }}
        >
          Start Free Trial
        </Typography>
        <Icon
          style={{
            fontWeight: "bold",
            marginLeft: 0,
            marginBottom: 0,
            marginTop: 0,
            padding: 0,
            marginLeft: "5px",
            fontSize: `${customfontsize}px`,
          }}
        >
          arrow_forward
        </Icon>
      </Button>
    </Box>
  );
};

export default TextSection;
